import {
  Alert,
  AutoComplete,
  Avatar,
  Button,
  Checkbox,
  Drawer,
  Form,
  Input,
  Modal,
  Rate,
  Select,
  Spin,
  Switch,
  Tag,
} from "antd";
import {
  BarcodeOutlined,
  CheckOutlined,
  CloseOutlined,
  ExclamationCircleOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
} from "@ant-design/icons";
import React, {
  ReactElement,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";

import axios from "axios";
import { authenticateToken } from "../../../utils/auth";
import { getImgUrl, getParamValue } from "../../../utils/index";
import Loading from "../../common/Loader";
import PaginationTwo from "../../common/PaginationTwo";
import { useLocation } from "react-router";
import Empty from "../../common/Empty";
import { responseNotification } from "../../../utils/notify";
import _, { debounce } from "lodash";
import ShopLayout from "../Layout";
import ShopHeader from "../Layout/topHeader";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faToggleOn } from "@fortawesome/free-solid-svg-icons";

const { confirm } = Modal;

export interface ProductCreateProps {
  total: number;
  categoriesOptions: any[];
  shopsOptions: any[];
  brandsOptions: any[];
  refetch: () => void;
  setType: (val) => void;
  type?: string;
}

const { Option } = Select;

const ShopRecycleBinList = (params): ReactElement => {
  const { shopInfo } = useSelector((state) => (state as any)?.authReducer);
  const shopId = shopInfo?.id;
  // --------------------------------
  const [multipleStatus, setMultipleStatus] = useState<string>();
  const [loading, setLoading] = useState(false);
  const [checkedList, setCheckedList] = React.useState([]);
  const [indeterminate, setIndeterminate] = React.useState(true);
  const [checkAll, setCheckAll] = React.useState(false);
  // --------------------------------

  const [status, setStatus] = useState("");
  const [limit, setLimit] = useState(100);
  const [type, setType] = useState(shopInfo?.type || "JC_MART");
  const [visible, setVisible] = useState(undefined);
  const [key, setKey] = useState("");
  const [barCode, setBarCode] = useState("");
  const [isDeleted, setIsDeleted] = useState(true);
  const [activeSearch, setActiveSearch] = useState(undefined);
  const [activeDelete, setActiveDelete] = useState(undefined);

  const [selectedProductBarcode, setSelectedProductBarcode] = useState([]);
  const [selectedShopId, setSelectedShopId] = useState();
  const [productBarcodeOptions, setProductBarcodeOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [productOptions, setProductOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [parentCatOptions, setParentCatOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [categoriesOptions, setCategoriesOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [brandId, setBrandId] = useState<any>();
  const [parentCatId, setParentCatId] = useState();
  const [categoryId, setCategoryId] = useState<any>();

  const [brandsOptions, setBrandsOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [shopProductData, setShopProductData] = useState({
    loading: false,
    data: null,
  });

  const router = useLocation();
  const page = getParamValue(router?.search, "page");
  const [form] = Form.useForm();
  const fetchRef = useRef(null);

  const reseAllFieldData = () => {
    setKey("");
    setBarCode("");
    setType("");
    setCategoryId("");
    setBrandId("");
    form.resetFields();
  };

  function showPromiseConfirm() {
    confirm({
      onOk() {
        return new Promise((resolve, reject) => {
          setMultipleStatus("RESTORE");
          setTimeout(Math.random() > 0.8 ? resolve : reject, 1500);
        }).catch(() => console.log("Oops errors!"));
      },
      cancelButtonProps: { type: "dashed" },
      cancelText: "CANCEL",
      okText: "RESTORE",
      okType: "danger",
      title: "Do you want to RESTORE selected Product's?",
      icon: <ExclamationCircleOutlined />,
      content:
        "When clicked the OK, Selected items will be RESTORED in this shop!",
      onCancel() {
        setVisible(false);
        // return new Promise((resolve, reject) => {
        //   setMultipleStatus("ACTIVE");
        //   setTimeout(Math.random() > 0.8 ? resolve : reject, 1500);
        // }).catch(() => console.log("Oops errors!"));
      },
    });
  }

  // **********************************
  // Search Options
  // **********************************

  const getBrandsOptions = useCallback(
    async (val?: string) => {
      setBrandsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/brand/search?page=0&limit=20` +
          (type ? `&type=${type}` : ``) +
          (val ? `&key=${val}` : ``),

        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setBrandsOptions({
        loading: false,
        list: res?.data?.brands?.map((brand) => {
          return {
            id: brand?.id,
            name: brand?.name,
          };
        }),
      });
    },
    [type]
  );

  const getProductByBarcodeOptions = useCallback(
    async (bCode) => {
      setProductBarcodeOptions({ loading: false, list: [] });

      setProductBarcodeOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;

      const res = await axios.get(
        `${encodedUri}/admin/product/search?page=0&limit=20&isDeleted=${true}` +
          (bCode ? `&barCode=${bCode}` : ``) +
          (key ? `&key=${key}` : ``) +
          (type ? `&type=${type}` : ``) +
          // (isDeleted ? `&isDeleted=${isDeleted}` : ``) +
          (status ? `&status=${status}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setProductBarcodeOptions({
        loading: false,
        list: res?.data?.keys?.map((product: { name: any; barCode: any }) => {
          return {
            value: product?.barCode,
            label: product?.name,
          };
        }),
      });
    },
    [status, type, key, isDeleted]
  );

  const getProductOptions = useCallback(
    async (val) => {
      setProductOptions({ loading: false, list: [] });

      setProductOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;

      const res = await axios.get(
        `${encodedUri}/admin/product/search?page=0&limit=20&isDeleted=${true}` +
          (val ? `&key=${val}` : ``) +
          (shopId ? `&shopId=${shopId}` : ``) +
          (barCode ? `&barCode=${barCode}` : ``) +
          (type ? `&type=${type}` : ``) +
          // (isDeleted ? `&isDeleted=${isDeleted}` : ``) +
          (status ? `&status=${status}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setProductOptions({
        loading: false,
        list: res?.data?.keys?.map((product: { name: any }) => {
          return {
            value: product?.name,
            label: product?.name,
          };
        }),
      });
    },
    [status, type, barCode, isDeleted]
  );
  // **********************************
  // Search Options
  // **********************************

  const getShopProduct = useCallback(
    (getShopId) => {
      if (getShopId) {
        try {
          setShopProductData({ loading: true, data: undefined });
          axios
            .get(
              `${process.env.REACT_APP_CATALOG_READER_API}/admin/product/?shopId=${getShopId}` +
                `&page=${page || 0}` +
                `&limit=${limit || 16}` +
                (status ? `&status=${status}` : ``) +
                (key ? `&key=${key}` : ``) +
                (barCode ? `&barCode=${barCode}` : ``) +
                (categoryId
                  ? `&categoryId=${categoryId}`
                  : parentCatId
                  ? `&categoryId=${parentCatId}`
                  : ``) +
                (brandId ? `&brandId=${brandId}` : ``) +
                (type ? `&type=${type}` : ``) +
                (isDeleted ? `&isDeleted=${isDeleted}` : ``),
              {
                headers: {
                  Authorization: `Bearer ${authenticateToken()}`,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((data) => {
              if (data.status === 200) {
                setShopProductData({
                  loading: false,
                  data: data?.data,
                });
                setCheckedList(
                  data.data.products.map((product) => product?.barCode)
                );
              } else {
                setShopProductData({ loading: false, data: null });
                responseNotification(
                  data.statusText || "something went wrong",
                  "error"
                );
              }
            })
            .catch((err) => {
              setShopProductData({ loading: false, data: null });

              console.log(err);
            });
        } catch (error) {
          setShopProductData({ loading: false, data: null });

          console.log(error, "error");
        }
      }
    },
    [
      limit,
      page,
      status,
      parentCatId,
      categoryId,
      brandId,
      key,
      barCode,
      type,
      isDeleted,
    ]
  );

  const getParentCatOptions = useCallback(
    async (val?: string) => {
      setParentCatOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/hub/categories/admin?id=${shopInfo?.hubId}&page=0&limit=20` +
          (val ? `&name=${val}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setParentCatOptions({
        loading: false,
        list: res?.data?.categories?.map((category) => {
          return {
            value: category?.category?.id,
            label: category?.category?.title,
          };
        }),
      });
    },
    [type]
  );

  const getCategoriesOptions = useCallback(
    async (val?: string) => {
      setCategoriesOptions({ loading: true, list: [] });
      if (shopInfo?.hubId) {
        if (parentCatId) {
          const res = await axios.get(
            `${process.env.REACT_APP_CATALOG_READER_API}/admin/category/child-category-by-parent?categoryId=${parentCatId}` +
              (val ? `&key=${val}` : ``) +
              (type ? `&type=${type}` : ``),
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
              },
            }
          );
          setCategoriesOptions({
            loading: false,
            list: res?.data?.categories?.map((category) => {
              return {
                value: category?.id,
                label: category?.title,
              };
            }),
          });
        } else {
          const res = await axios.get(
            `${process.env.REACT_APP_CATALOG_READER_API}/admin/category/child-category-by-hub?hubId=${shopInfo?.hubId}&page=0&limit=20` +
              (val ? `&key=${val}` : ``) +
              (type ? `&type=${type}` : ``),
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
              },
            }
          );
          setCategoriesOptions({
            loading: false,
            list: res?.data?.categories?.map((category) => {
              return {
                value: category?.id,
                label: category?.title,
              };
            }),
          });
        }
      } else {
        const res = await axios.get(
          `${process.env.REACT_APP_CATALOG_READER_API}/admin/shop/categories?shopId=${shopId}&page=0&limit=20` +
            (val ? `&key=${val}` : ``) +
            (type ? `&type=${type}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        );
        setCategoriesOptions({
          loading: false,
          list: res?.data?.categories?.map((category) => {
            return {
              value: category?.category?.id,
              label: category?.category?.title,
            };
          }),
        });
      }
    },
    [type, parentCatId]
  );

  const onDelete = async (id, val) => {
    if (id) {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/product`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          deleted: !val,
          isActive: true,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification("Status Updated Successfully", "success");
            getShopProduct(shopId);
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  const onMultipleStatusChange = async () => {
    await fetch(
      `${process.env.REACT_APP_CATALOG_WRITER_API}/product/multiple-active-inactive`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          barCodes: selectedProductBarcode,
          deleted: multipleStatus === "RESTORE" ? false : true,
          isActive: false,
          shopIds: selectedShopId || [shopId],
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.statusCode === 200) {
          responseNotification(
            "Selected Item(s) Status Updated Successfully",
            "success"
          );
          getShopProduct(shopId);
          setVisible(false);
          form.resetFields();
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };
  //

  const onChange = (e) => {
    setSelectedProductBarcode((prevVal: any) => {
      const newVal = e;
      let newArr = Array.from(prevVal);
      const found = prevVal.find((item) => item === newVal);
      if (!found) {
        newArr.push(newVal);
      } else {
        newArr = newArr.filter((item) => item !== newVal);
      }
      return newArr;
    });

    setIndeterminate(
      !!checkedList.length &&
        checkedList.length <= selectedProductBarcode.length
    );
    setCheckAll(checkedList.length === selectedProductBarcode.length);
  };

  const onCheckAllChange = (e) => {
    setSelectedProductBarcode(e.target.checked ? checkedList : []);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };

  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }

      if (value) {
        if (field === "product") getProductOptions(value);
        else if (field === "productByBarcode")
          getProductByBarcodeOptions(value);
        else if (field === "parentCategory") getParentCatOptions(value);
        else if (field === "category") getCategoriesOptions(value);
        else if (field === "brand") getBrandsOptions(value);
      }
    };

    return debounce(loadOptions, 800);
  }, [
    getParentCatOptions,
    getCategoriesOptions,
    getBrandsOptions,
    getProductOptions,
    getProductByBarcodeOptions,
  ]);

  useEffect(() => {
    if (multipleStatus) {
      onMultipleStatusChange();
    }
  }, [multipleStatus]);

  useEffect(() => {
    getShopProduct(shopId);
  }, [getShopProduct, shopId]);

  useEffect(() => {
    if (activeSearch) {
      getParentCatOptions();
      getCategoriesOptions();
      getBrandsOptions();
    }
  }, [
    getBrandsOptions,
    getParentCatOptions,
    getCategoriesOptions,
    activeSearch,
  ]);

  useEffect(() => {
    if (activeDelete) {
      form.resetFields();
    }
  }, [activeDelete]);

  useEffect(() => {
    if (parentCatId) {
      setCategoryId(undefined);
      form.resetFields(["sub_category_search"]);
    }
  }, [setCategoryId, parentCatId]);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    form.resetFields();
    setVisible(false);
    setActiveDelete(undefined);
  };

  return (
    <React.Fragment>
      <ShopLayout shopId={shopId}>
        <>
          <section className="product-lists">
            <div className="product-list-item-area white-bg">
              <ShopHeader
                leftarea={"Recycle Bin"}
                rightarea={
                  <div className="d-flex">
                    {activeSearch ? (
                      <Button
                        type="dashed"
                        onClick={() => {
                          setActiveSearch(false);
                          reseAllFieldData();
                        }}
                        danger
                      >
                        <ZoomOutOutlined />
                      </Button>
                    ) : (
                      <Button
                        type="dashed"
                        onClick={() => {
                          setActiveSearch(true);
                        }}
                      >
                        <ZoomInOutlined />
                      </Button>
                    )}
                    <Button
                      type="primary"
                      danger
                      onClick={() => {
                        showDrawer();
                        setActiveDelete(true);
                      }}
                      disabled={!selectedProductBarcode.length}
                      className="ml-2"
                      title="Change Staus"
                    >
                      <FontAwesomeIcon icon={faToggleOn} />
                    </Button>
                  </div>
                }
              />

              {activeSearch && (
                <div className="search_area mb-0">
                  <Form form={form} className="search_form">
                    <Form.Item name="barcode_search" initialValue={barCode}>
                      <AutoComplete
                        onSearch={(e) => handleSearch(e, "productByBarcode")}
                        onSelect={(val) => setBarCode(val)}
                        options={productBarcodeOptions?.list}
                        defaultActiveFirstOption={false}
                        notFoundContent={
                          productBarcodeOptions?.loading ? (
                            <Spin size="small" />
                          ) : null
                        }
                      >
                        <Input.Search
                          size="large"
                          placeholder="Search by BarCode"
                          onSearch={(val) => {
                            setBarCode(val);
                          }}
                          enterButton
                          loading={productBarcodeOptions.loading}
                          pattern={`[0-9]`}
                          maxLength={11}
                        />
                      </AutoComplete>
                    </Form.Item>

                    <Form.Item name="product_search" initialValue={key}>
                      <AutoComplete
                        onSearch={(e) => handleSearch(e, "product")}
                        onSelect={(val) => setKey(val.toString())}
                        options={productOptions?.list}
                        defaultActiveFirstOption={false}
                        notFoundContent={
                          productOptions?.loading ? <Spin size="small" /> : null
                        }
                      >
                        <Input.Search
                          size="large"
                          placeholder="Search by Name"
                          onSearch={(val) => {
                            setKey(val);
                          }}
                          enterButton
                          loading={productOptions.loading}
                          pattern={`[0-9]`}
                          maxLength={11}
                        />
                      </AutoComplete>
                    </Form.Item>

                    <Form.Item name="parentCategory_search">
                      <Select
                        allowClear
                        showSearch
                        placeholder="Filter by Category"
                        optionFilterProp="children"
                        onChange={(val) => setParentCatId(val)}
                        onSearch={(e) => handleSearch(e, "parentCategory")}
                        filterOption={(input, option) =>
                          option.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {parentCatOptions?.list?.map((category) => (
                          <Option value={category.value}>
                            {category.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <Form.Item name="sub_category_search">
                      <Select
                        allowClear
                        showSearch
                        placeholder="Sub Category"
                        optionFilterProp="children"
                        onChange={(val) => setCategoryId(val)}
                        onSearch={(e) => handleSearch(e, "category")}
                        filterOption={(input, option) =>
                          option.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {categoriesOptions?.list?.map((category) => (
                          <Option value={category.value}>
                            {category.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Form>
                  <div className="search_btn">
                    <Button
                      type="primary"
                      size="large"
                      danger
                      onClick={reseAllFieldData}
                    >
                      Reset
                    </Button>
                  </div>
                </div>
              )}

              <div className="">
                <div className="product-list-items-inner-content">
                  <div className="single-product-wrapper">
                    <div className="single-product-heading major">
                      <Checkbox
                        indeterminate={indeterminate}
                        onChange={onCheckAllChange}
                        checked={
                          checkAll ||
                          selectedProductBarcode?.length === checkedList?.length
                        }
                        className="mr-3"
                      >
                        Check all
                      </Checkbox>
                    </div>
                    <div className="single-product-heading major">
                      <span>Stock & Price</span>
                    </div>
                    <div className="single-product-heading major">
                      <span>Ratting</span>
                    </div>
                    <div className="single-product-heading">
                      <span>Restore</span>
                    </div>
                  </div>
                </div>
              </div>

              {shopProductData.loading ? (
                <Loading />
              ) : (
                <div className="product-table">
                  <div className="product-table-area">
                    {shopProductData?.data?.products?.length ? (
                      shopProductData?.data?.products?.map(
                        (product: any, index: number) => (
                          <React.Fragment key={index}>
                            {/* <Link
                              to={`/shops/${
                                (route as any)?.shopId as string
                              }/products/${product?.slug}/details`}
                            > */}
                            <div className="single-product-wrapper">
                              <div className="single-product major">
                                <Checkbox
                                  onClick={(e) => {
                                    e.preventDefault();
                                    onChange(product?.barCode);
                                  }}
                                  checked={selectedProductBarcode?.find(
                                    (item) => product?.barCode === item
                                  )}
                                  className="mr-3"
                                  value={product?.barCode}
                                />
                                <Avatar
                                  shape="square"
                                  size={50}
                                  src={getImgUrl(product?.productImage)}
                                  className="mr-3"
                                />
                                <span className="name">{product?.name}</span>
                              </div>

                              <div className="single-product major">
                                <div className="">
                                  {product?.variations?.length
                                    ? product?.variations?.map(
                                        (variant, index) => (
                                          <React.Fragment key={index}>
                                            <div className="d-flex justify-content-start mb-1">
                                              {variant?.barCode ? (
                                                <Tag className="d-flex align-items-center">
                                                  <BarcodeOutlined className="mr-1" />{" "}
                                                  {variant?.barCode}
                                                </Tag>
                                              ) : product?.barCode ? (
                                                <Tag className="d-flex align-items-center">
                                                  <BarcodeOutlined className="mr-1" />{" "}
                                                  {product?.barCode}
                                                </Tag>
                                              ) : undefined}
                                              <Tag
                                                color={
                                                  variant?.stock < 10
                                                    ? `red`
                                                    : `green`
                                                }
                                              >
                                                {variant?.variationName?.toUpperCase()}
                                                : <b>{variant?.stock || 0}</b>
                                              </Tag>
                                            </div>
                                            <div className="d-flex justify-content-start mb-1">
                                              <Tag>
                                                MRP{" "}
                                                {variant?.price?.currencyCode}
                                                {variant?.price
                                                  ?.discountedPrice ||
                                                  variant?.price?.mrp}
                                                {variant?.price
                                                  ?.discountedPrice &&
                                                  variant?.price
                                                    ?.discountedPrice !==
                                                    variant?.price?.mrp && (
                                                    <span className="text-danger">
                                                      {" "}
                                                      <del>
                                                        {variant?.price
                                                          ?.currencyCode ||
                                                          "Tk"}
                                                        {variant?.price?.mrp}
                                                      </del>
                                                    </span>
                                                  )}
                                              </Tag>
                                              <Tag>
                                                TP {variant?.price?.tp}{" "}
                                                {variant?.price?.currencyCode}
                                              </Tag>
                                            </div>
                                          </React.Fragment>
                                        )
                                      )
                                    : undefined}
                                </div>
                              </div>

                              <div className="single-product">
                                <span className="name d-flex-l">
                                  {product?.numberOfRating ? (
                                    <Rate
                                      value={product?.rating || 0}
                                      disabled
                                    />
                                  ) : (
                                    <Rate value={0} disabled />
                                  )}
                                  {product?.numberOfRating ? (
                                    <small className="ml-1">
                                      ({product?.numberOfRating})
                                    </small>
                                  ) : undefined}
                                </span>
                              </div>
                              <div className="single-product">
                                <Switch
                                  checkedChildren={<CheckOutlined />}
                                  unCheckedChildren={<CloseOutlined />}
                                  defaultChecked={!product?.deleted}
                                  onChange={(val, e) => {
                                    e.preventDefault();
                                    onDelete(product?.id, val);
                                  }}
                                />
                              </div>
                            </div>
                            {/* </Link> */}
                          </React.Fragment>
                        )
                      )
                    ) : (
                      <Empty data="Products" />
                    )}
                  </div>
                </div>
              )}
              <PaginationTwo
                {...shopProductData?.data}
                limit={limit}
                page={shopProductData?.data?.currentPageNumber || 0}
              />
            </div>
          </section>
        </>
      </ShopLayout>
      <Drawer
        title="Change Status"
        placement="right"
        onClose={onClose}
        visible={visible}
        width={400}
      >
        <div className="">
          <Form
            name="control-hooks"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            className="ant-form ant-form-vertical"
            onFinish={onMultipleStatusChange}
            form={form} // like ref
            layout="vertical"
            autoComplete="off"
            initialValues={{
              shopId: !activeDelete ? [shopId] : undefined,
            }}
          >
            {activeDelete && (
              <Alert
                message="Are you sure to RESTORE selected Product's"
                type="info"
                banner
                closable
                onClose={onClose}
                className="mb-4"
              />
            )}

            <Button
              onClick={() => showPromiseConfirm()}
              type="primary"
              title="Change Status"
              disabled={!checkedList}
              htmlType="button"
              size="large"
            >
              <FontAwesomeIcon icon={faToggleOn} className="mr-2" /> Restore
              Items
            </Button>
          </Form>
        </div>
      </Drawer>
    </React.Fragment>
  );
};

export default ShopRecycleBinList;
